import type { ChatContext } from '../../chat';
import type { UrlTilePayload } from '../../url-tiles';
import {
    JSA_CLUSTER_DETAIL_TILE_TYPE,
    JSA_FAMILY_DETAIL_TILE_TYPE,
    JSA_PROFILE_DETAIL_TILE_TYPE,
    jsaClusterDetailTileSchema,
    jsaFamilyDetailTileSchema,
    jsaProfileDetailTileSchema,
} from '../url-tile-payloads';

export const jobArchitectureUrlTileChatTypes: readonly string[] = [
    JSA_PROFILE_DETAIL_TILE_TYPE,
    JSA_FAMILY_DETAIL_TILE_TYPE,
    JSA_CLUSTER_DETAIL_TILE_TYPE,
];

export const getJobArchitectureUrlTileChatContext = (payload: UrlTilePayload): ChatContext | undefined => {
    const profilePayload = jsaProfileDetailTileSchema.safeParse(payload);

    if (profilePayload.success) {
        return {
            architectureId: profilePayload.data.architectureId,
            itemId: profilePayload.data.profileId,
            itemType: profilePayload.data.itemType,
            kind: 'job-profile',
            preferredLanguage: profilePayload.data.preferredLanguage,
            version: profilePayload.data.version,
        };
    }

    const familyPayload = jsaFamilyDetailTileSchema.safeParse(payload);

    if (familyPayload.success) {
        return {
            architectureId: familyPayload.data.architectureId,
            familyId: familyPayload.data.familyId,
            kind: 'job-family',
        };
    }

    const clusterPayload = jsaClusterDetailTileSchema.safeParse(payload);

    if (clusterPayload.success) {
        return {
            architectureId: clusterPayload.data.architectureId,
            clusterId: clusterPayload.data.clusterId,
            familyId: clusterPayload.data.familyId,
            kind: 'job-cluster',
        };
    }

    return undefined;
};
